// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pw4K","delete":"styles_delete__1HVtp","update":"styles_update__2KlQN","add":"styles_add__2BVfn"};